<template>
  <div>
    <set-banner-create-edit-form />
  </div>
</template>

<script>
  import SetBannerCreateEditForm from './components/SetBannerCreateEditForm.vue';

  import useCreateSetBanner from './hooks/useCreateSetBanner';
  export default {
    components: {
      SetBannerCreateEditForm,
    },

    setup() {
      const { bannerListTableConfig } = useCreateSetBanner();

      return { bannerListTableConfig };
    },
  };
</script>

<style></style>
